export const OUR_OFFERINGS = "Our Offerings";

export const ICONS_MAP = {
    SAAS_DEVELOPMENT: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-saas.png`,
    PRODUCT_IDEATION: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-product-ideation.png`,
    UI_UX_DESIGN: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-ui-ux-design.png`,
    MVP: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-mvp.png`,
    SCALING_MAINTENANCE: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-scaling-maintenance.png`,
}